import { render, staticRenderFns } from "./printDeliver.vue?vue&type=template&id=5c445a1f&scoped=true&"
import script from "./printDeliver.vue?vue&type=script&lang=js&"
export * from "./printDeliver.vue?vue&type=script&lang=js&"
import style0 from "./printDeliver.vue?vue&type=style&index=0&id=5c445a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c445a1f",
  null
  
)

export default component.exports